import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Property } from '@app/shared/interfaces';
import { PropertyAvailabilityRulesFormComponent } from '@app/shared/components/property-availability-rules-form/property-availability-rules-form.component';
import { CommonModule } from '@angular/common';
import { UiModule } from '@app/ui';

@Component({
  standalone: true,
  selector: 'sbnb-sidebar-availability',
  templateUrl: './sidebar-availability.component.html',
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PropertyAvailabilityRulesFormComponent, CommonModule, UiModule],
})
export class SidebarAvailabilityComponent {
  @Input() property!: Property;
  // todo add flag for better structure in the actual availability component
}
